import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import * as userStore from "../../../user/store/user.store";
import { LoaderDelay } from "../../../../components/loaders";
import * as commentsStore from "../../store/comments.store";
import { CommentsProps } from "./comments.props";
import { CommentsView } from "../comments-view/comments-view.component";

export const Comments: React.FC<CommentsProps> = (props: CommentsProps) => {
  const comments = useSelector(commentsStore.getComments);
  const isLoading = useSelector(commentsStore.isLoading);
  const userProfile = useSelector(userStore.getProfile);

  useEffect(() => {
    if (!comments) {
      commentsStore.fetchComments(props.modelId, props.modelName);
    }
  }, [comments, props.modelId, props.modelName]);

  const handleAddComment = (text: string) => {
    setTimeout(() => {
      commentsStore.postComment(props.modelId, props.modelName, text);
    }, LoaderDelay);
  };

  return (
    <CommentsView
      isLoading={isLoading}
      user={userProfile}
      comments={comments}
      onPostComment={handleAddComment}
    />
  );
};
